export default __webpack_public_path__ + "static/AppCV4-0f63172486d2bd596f84d22aabd59026.png";